import localStorageUtil from '@/common/utils/localStorageUtil';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import './OverFlowTooltip.css';
import Utils from '@/common/utils/utils';

export default function OverFlowTooltipCheckBox(props) {
    // Create Ref
    const textElementRef = useRef();
    let projectInUseId = localStorageUtil.getSelectedProjectId();
    const compareSize = () => {
        const compare = textElementRef?.current?.scrollWidth > textElementRef?.current?.clientWidth;
        setHover(compare);
    };

    // compare once and add resize listener on "componentDidMount"
    useEffect(() => {
        compareSize();
        const myComponent = document.getElementById(props.id);
        const childComponents = myComponent.childNodes;
        if (!Utils.isEmptyArray(childComponents)) {
            let spanNode = childComponents[1];
            if(spanNode?.scrollWidth && spanNode?.clientWidth){
                const compare = spanNode?.scrollWidth > spanNode?.clientWidth;
                setHover(compare);
            }
        }
        window.addEventListener('resize', compareSize);
    }, [projectInUseId, props]);

    // remove resize listener again on "componentWillUnmount"
    useEffect(() => {
        window.removeEventListener('resize', compareSize);
    }, [projectInUseId, props]);

    // Define state and function to update the value
    const [hoverStatus, setHover] = useState(false);
    return (
        <Tooltip title={props.value} disableHoverListener={!hoverStatus} placement="top" arrow>
            <p>
            <FormControlLabel
                control={
                    <Checkbox
                        className="hello"
                        checked={props.status === 'checked'}
                        name="jason"
                        indeterminate={props.indeterminate}
                        onChange={e => props.handleOnChange(props.item)}
                    />
                }
                label={`${props.name}`}
                className={`checkbox-item-of-tag-field label-item-name`}
                id={props.id}
            />
            </p>
        </Tooltip>
    );
}

OverFlowTooltipCheckBox.defaultProps = {
    value: ''
};
